import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@moleculeone/ui';
import { Mol } from '@retro-ui/api-contract';

type AtomProps = {
  symbol: string;
  onPickAtom: (mol: Mol) => void;
  active: boolean;
};
export const Atom = ({ symbol, onPickAtom, active }: AtomProps) => {
  const pickAtom = e => {
    e.stopPropagation();

    onPickAtom({
      atoms: {
        0: { idx: '0', charge: 0, element: symbol },
      },
      bonds: {},
      nextAtom: 1,
      nextBond: 0,
      positions: {
        0: [0, 0, 0],
      },
    });
  };

  return (
    <Button
      weight="minimal"
      size="small"
      text={symbol}
      onClick={pickAtom}
      data-test={`common-atom-button-${symbol}`}
      active={active}
      css={{ fontSize: '$3', fontWeight: 300 }}
    />
  );
};

Atom.propTypes = {
  symbol: PropTypes.string,
  onPickAtom: PropTypes.func,
};
